import type { DSSPaymentFrequency } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useRecoilValue } from 'recoil';
import ProductAndPrice from './ProductAndPrice';
import { sortedCoverablesListSelector } from '../../../recoil/selectors/sortedCoverablesListSelector';
import { businessFlowSelector } from '../../../recoil/selectors/getBusinessFlowSelector';

const ProductAndPriceList = ({
    paymentFrequency,
    isPaymentYearly,
    shouldHideDetails = false
}: {
    paymentFrequency: DSSPaymentFrequency;
    isPaymentYearly: boolean;
    shouldHideDetails?: boolean;
}): React.JSX.Element => {
    const { sortedCoverables } = useRecoilValue(sortedCoverablesListSelector);
    const isMPSBusinessFlow = useRecoilValue(businessFlowSelector) === 'MPS';
    const coverables = isMPSBusinessFlow
        ? [...sortedCoverables.filter((coverable) => !coverable.willSpinOff)]
        : [...sortedCoverables];
    return (
        <div>
            {coverables.map((coverable) => {
                return (
                    <div key={coverable.fixedId}>
                        <ProductAndPrice
                            coverable={coverable}
                            paymentFrequency={paymentFrequency}
                            isPaymentYearly={isPaymentYearly}
                            shouldHideDetails={shouldHideDetails}
                        />
                        <hr className={'u-spacing-stack-none'} />
                    </div>
                );
            })}
        </div>
    );
};

export default ProductAndPriceList;
